import React from 'react'
import Image from 'gatsby-image'
import classNames from 'classnames'
import { useUniqueIds } from '../../utilities/general'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import diagonal from '../../images/diagonal-pattern-small.svg'
import styles from './icon-boxes.module.scss'
import shared from '../shared.module.scss'

const IconBoxesSlice = ({ slice }) => {
  const { items } = slice

  const {
    icon_boxes_title,
    icon_boxes_span_small,
    icon_boxes_per_row,
    icon_boxes_has_diagonal,
    icon_boxes_icon_position,
    icon_boxes_container_fluid,
    icon_boxes_margin_bottom,
    icon_boxes_text_color,
    icon_boxes_background_color,
  } = slice.primary

  const colWidths = {
    auto: 'auto',
    1: 12,
    2: 6,
    3: 4,
    4: 3,
    6: 2,
    12: 1,
  }

  const itemWithIds = useUniqueIds( items )

  return (
    <section
      className={ classNames( styles.section, {
        [ styles.margin ]: icon_boxes_margin_bottom,
        [ shared.padding ]: icon_boxes_background_color,
      })}
      style={{
        color: icon_boxes_text_color,
        backgroundColor: icon_boxes_background_color,
      }}
    >
      { icon_boxes_has_diagonal && (
        <img className={ styles.diagonal } src={ diagonal } alt={ icon_boxes_title } />
      )}

      <Container fluid={ icon_boxes_container_fluid }>
        { icon_boxes_title && (
          <h2 className={ styles.header }>{ icon_boxes_title }</h2>
        )}

        <Row gutter="5rem" align="start" justify="around">
          { !! itemWithIds.length && itemWithIds.map( item => (
            <Col
              key={ item.uniqueId }
              span={ icon_boxes_span_small }
              md={ colWidths[ icon_boxes_per_row ] }
              className={ classNames( styles.box, {
                [ styles.iconTop ]: icon_boxes_icon_position === 'top',
                [ styles.iconLeft ]: icon_boxes_icon_position === 'left',
              })}
            >
              <Image className={ styles.icon } fixed={ item.icon_boxes_icon.fixed } />

              <div className={ styles.right }>
                { item.icon_boxes_title && (
                  <p className={ styles.title }>{ item.icon_boxes_title }</p>
                )}

                { item.icon_boxes_content.text && (
                  <div
                    className={ styles.content }
                    dangerouslySetInnerHTML={{ __html: item.icon_boxes_content.html }}
                  />
                )}
              </div>
            </Col>
          )) }
        </Row>
      </Container>
    </section>
  )
}

export default IconBoxesSlice
